module.exports = __webpack_public_path__ + "static/media/1.3f103e2b.jpg";